import { constants } from 'modules/common';

export const isSortCodeValid = (sortCode: string) => {
    const isInvalid = sortCode.length !== constants.xeroConstants.sortCodeMaxLength || /[^\d]/.test(sortCode);

    return !isInvalid;
};
